<template>
  <div>
    <label for="tipo-veiculo" class="required">Tipo de Veículo:</label>
    <select v-model="selected" @change="enviarEmit" id="tipo-veiculo">
      <option v-for="t in tiposVeiculo" :key="t.id" :value="t">
        {{ t.veiculo }}
      </option>
    </select>
  </div>
</template>
  
<script>
export default {
  name: 'TipoVeiculo',
  emits: ['tipo-veiculo-selecionado', 'capacidade-passageiro-selecionado'],
  props: {
    tipoViagem: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      tiposVeiculo: [],
      selected: ''
    };
  },

  methods: {

    async getTiposVeiculo() {
      try {
        const path = '/tipo_viagem/' + this.tipoViagem;
        const response = await this.$axios.get(path);
        this.tiposVeiculo = response.data;
      } catch (error) {
        if (error.response) {
          console.error('(buscando tipo veículos) Resposta do servidor com status:', error.response.status);
        } else {
          console.error('(buscando tipo veículos) Erro sem resposta do servidor:', error.message);
        }
      }
    },

    enviarEmit() {
      this.$emit('tipo-veiculo-selecionado', this.selected.veiculo);
      this.$emit('capacidade-passageiro-selecionado', this.selected.passageiro);
    }
  },

  mounted() {
     if (this.tipoViagem != null) {
       this.getTiposVeiculo();
     }
  },

  watch: {
    tipoViagem(){
      if (this.tipoViagem != null) {
        this.getTiposVeiculo();
      }
    }
  }

};
</script>
  
<style scoped>
/* Adicione estilos específicos para o componente aqui, se necessário */
</style>